// Footer.tsx
import React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div>
        <h2>Haaskel Web Design</h2>
        <p>
          We build clean, modern websites tailored to your brand. Design, development, and beyond.
        </p>
      </div>

      <div>
        <h3>Quick Links</h3>
        <ul>
          <li><a href="/services">Services</a></li>
          <li><a href="/aboutus">About Us</a></li>
          <li><a href="/consultation">Contact</a></li>
        </ul>
      </div>

      <div>
        <h3>Contact</h3>
        <p>NY, NY</p>
        <p>info@haaskel.com</p>
      </div>

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Haaskel Web Design. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
